// extracted by mini-css-extract-plugin
module.exports = {"wrap":"xq-z","articleImagesWrap":"yq-z","articleImage":"zq-z","singleImage":"Aq-z"};